export default __webpack_public_path__ + "static/media/sky-bg-desktop.209b898a.png";